
import React from 'react';
import Tabulation from './Tabulation';
import Keyboard from './Keyboard';
// ----------------------------------------------------------------
// 以下为使用例子----------------------------------------------------
// ----------------------------------------------------------------

type DemoRef = {
  current: any;
}

export default class Demo extends React.Component {
  constructor(props: any) {
    super(props);
    this.tabRef = React.createRef<DemoRef>();
  }

  tabRef: DemoRef

  state = {
    data: {
      od_test_0: '1',
      od_test_1: '2',
      od_test_2: '3',
      od_test_3: '444',
      od_test_4: '5',
      os_test_0: '6',
      os_test_1: '7',
      os_test_2: '8',
      os_test_3: '9',
      os_test_4: '10',
    },
    eyeType: 'OD',
  }

  onTabChange = (name: string, value: number | string, unavailableText: string): void => {
    let eyeType = '';

    if (/^od_/.test(name)) {
      eyeType = 'OD';
    } else {
      eyeType = 'OS';
    }
    eyeType !== this.state.eyeType && this.setState({ eyeType });
  }

  /**
   * 当前输入框的值改变时候
   */
  onInputChange = (name: any, value: any) => {
    const { data } = this.state;
    const test = { ...data, [name]: value };

    this.setState({
      data: test
    });
  }

  /**
   * 输入框失去焦点
   */
  onInputBlur = (name: any, value: any, element: any) => {
    // 本例是通过受控的state控制
    value = `+${value}`;
    this.onInputChange(name, value);
    // 如果是不是state受控的通过以下方法设置
    // this.tabRef.current.setValueByName(name, value);
  }

  /**
   * 下一页
   */
  onKeyNext = () => {
    this.tabRef.current.onNext();
  }

  /**
   * 键盘退格
   */
  onKeyBackspace = () => {
    this.tabRef.current.onBackspace();
  }

  /**
   * 类型切换
   * @param type 眼别类型
   */
  onKeyTypeChange = (type: string) => {
    let name = '';
    if (type === 'OD') {
      name = 'od_test_0';
    } else {
      name = 'os_test_0';
    }
    this.tabRef.current.inputAutoFocusByName(name);

    this.setState({ eyeType: type });
  }

  /**
   * inputKeyValueChange input的值返回，也可以在onInputChange方法中获取当前改变的值
   * @param value 键盘输入值改变
   */
  onKeyValueChange = (value: string) => {
    const inputValue = this.tabRef.current.inputKeyValueChange(value);
  }

  render() {
    const { eyeType, data } = this.state;
    // 重要1：Tabulation.TabInput 索引不能重复
    // 重要2：Tabulation.TabInput 索引应该是连续的
    // 重要3：Tabulation.TabInput 如果出现要跳过的输入框，它应该有索引并且是连续的，但是它的值是负数

    return (
      <div style={{ background: '#fff'}}>
        <Tabulation
          border // input输入框的的边框是否显示
          defaultMaxLength={1} // 整个组件默认的最大输入值，每个输入框可以通过 maxLength 自定义
          defaultUnavailableText="@./" // 整个组件默认的不可输入的字符
          onTabChange={this.onTabChange} // 焦点切换时回调 name, value, inputElement?
          onInputChange={this.onInputChange} // 输入时候回调 name, value, inputElement?
          onInputBlur={this.onInputBlur} // 输入框失去焦点后回调 name, value, inputElement?
          ref={this.tabRef}
        >
          <div style={{ display: 'flex' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>OD:</div>
            {/* 默认值不受控 */}
            <Tabulation.TabInput tabIndex={0} name="od_test_0" value={data.od_test_0} />
            {/* 值受控 */}
            <Tabulation.TabInput tabIndex={1} name="od_test_1" value={data.od_test_1} />
            {/* 禁止输入的字符 */}
            <Tabulation.TabInput tabIndex={2} name="od_test_2" value={data.od_test_2} />
            {/* 最大可输入范围 */}
            <Tabulation.TabInput tabIndex={3} name="od_test_3" maxLength={3} value={data.od_test_3} />
            {/* 当前input跳过 但是索引是连续的 && 为负数 */}
            <Tabulation.TabInput tabIndex={-4} name="od_test_4" value={data.od_test_4} />
          </div>
          <div style={{ display: 'flex' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>OS:</div>
            <Tabulation.TabInput tabIndex={5} name="os_test_0" value={data.os_test_0} />
            <Tabulation.TabInput tabIndex={6} name="os_test_1" value={data.os_test_1} />
            <Tabulation.TabInput tabIndex={7} name="os_test_2" value={data.os_test_2} />
            <Tabulation.TabInput tabIndex={8} name="os_test_3" value={data.os_test_3} />
            <Tabulation.TabInput tabIndex={-9} name="os_test_4" value={data.os_test_4} />
          </div>
        </Tabulation>
        <div>
          <Keyboard
            unavailableKeys={["@", '/', '00']}
            eyeType={eyeType}
            onKeyNext={this.onKeyNext}
            onKeyBackspace={this.onKeyBackspace}
            onKeyTypeChange={this.onKeyTypeChange}
            onKeyValueChange={this.onKeyValueChange}
          />
        </div>
      </div>
    );
  }
}